/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */
import { cssVar } from '@touchplan/css-var';

import { InsertionPointLabelTextConfiguration } from './InsertionPointLabelContainer';

enum INSERTION_POINT_TEXTURES {
	INSERTION_POINT_RECTANGLE = 'insertionPointRectangle',
}

const INSERTION_POINT_LABEL_STYLE = {
	paddingTop: cssVar.space4_px,
};

const INSERTION_POINT_TEXT_CONFIGURATION: InsertionPointLabelTextConfiguration = {
	fontSize: cssVar.h4FontSize_px,
	fill: cssVar.white_number,
	fontFamily: cssVar.fontFamily,
};

const INSERTION_POINT_GLOBAL_SETTINGS = {
	topLineHeight: 2,
	height: 25,
	backgroundColor: cssVar.touchplanBlue900_number,
	topLineBackgroundColor: cssVar.touchplanAccent_number,
};

export {
	INSERTION_POINT_TEXTURES,
	INSERTION_POINT_LABEL_STYLE,
	INSERTION_POINT_GLOBAL_SETTINGS,
	INSERTION_POINT_TEXT_CONFIGURATION,
};
